import type { ComponentPropsWithoutRef } from "react";
import { useId } from "react";

import { Label } from "./Label";
import { Description } from "./Description";
import { getInputFieldClasses } from "../../utils/getInputFieldClasses";
import { ErrorMessage, type ErrorKey } from "./ErrorMessage";

type Size = "sm" | "md" | "lg";

interface InputProps extends Omit<ComponentPropsWithoutRef<"input">, "size"> {
  label: string;
  description?: string;
  error?: ErrorKey;
  size?: Size;
}

export const Input = ({
  label,
  description,
  error,
  id,
  required,
  size = "md",
  ...inputProps
}: InputProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={inputId} label={label} required={required} />

      <input
        {...inputProps}
        id={inputId}
        required={required}
        aria-invalid={error ? true : undefined}
        className={getInputFieldClasses(size, !!error)}
      />

      {error && <ErrorMessage error={error} />}
      {description && !error && <Description description={description} />}
    </div>
  );
};
